export default __webpack_public_path__ + "static/media/honesty.9715c51d.png";